import React from 'react';

// Copy is verbatim from the design-pass ticket. The sequenced-funding
// mechanic is the reason Trade Offers exist; sequencing is framed as how the
// trade becomes possible, never as a restriction.
const STEPS = [
  { title: 'Your card ships.', detail: 'The side that can cover its escrow goes first.' },
  { title: 'It pays you.', detail: 'Points land in your balance on delivery.' },
  { title: 'Their card ships.', detail: 'Funded by what you just earned, automatically.' },
];

const FundingSteps: React.FC = () => (
  <section className="offers-zero-funding" aria-label="How funding works">
    <h2 className="offers-zero-funding-heading">You don&apos;t need points to trade this way</h2>
    <ol className="offers-zero-funding-steps">
      {STEPS.map((step, i) => (
        <li key={step.title} className="offers-zero-funding-step">
          <span className="offers-zero-funding-step-num">{i + 1}</span>
          <div>
            <div className="offers-zero-funding-step-title">{step.title}</div>
            <div className="offers-zero-funding-step-detail">{step.detail}</div>
          </div>
        </li>
      ))}
    </ol>
  </section>
);

export default FundingSteps;
